import { Query } from 'acast-reactor';
import request from 'superagent';
import config from 'app/config';
import { getUserToken } from 'services/authentication';

export default Query.define('showstatslistens/read', showId => {
  const host = config.get('INSIGHTS_API_HOST');
  const endpoint = `${host}/api/v2/charts/overview/${showId}`;

  return new Promise((resolve, reject) => {
    request
      .get(endpoint)
      .set('Authorization', `Bearer ${getUserToken()}`)
      .set('Content-Type', 'application/json; charset=utf-8')
      .end((err, res) => {
        if (err || !res.ok) {
          reject(res);
        } else {
          resolve(res.body);
        }
      });
  });
});
